import React from 'react';
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { useNavigateWithSlugHook, } from "../../../../src/config/routes/guards/slug";

const DatatableMapingGroups = (props) => {
  const navigate = useNavigateWithSlugHook();
  const handleChangePage = (path) => {
    navigate(path);
  };

  const columns = [
    {
      name: 'Aksi',
      width: '100px',
      cell: (row) => (
        <>
          <button
            className="btn btn-danger btn-sm"
            type="button"
            onClick={() => props.handleEdit(row)}
          >
            Edit
          </button>
        </>
      ),
    },
    {
      name: 'Nama Lengkap',
      selector: (row) => row?.user?.namaLengkap,
    },
    {
      name: 'Group',
      selector: (row) => row?.group?.namaGroup,
    },
    {
      name: 'Module',
      selector: (row) => row?.module?.namaModule,
    },
    {
      name: 'Created At',
      selector: (row) => row.createdAt,
    },
    {
      name: 'Updated At',
      selector: (row) => row.updatedAt,
    },
  ];

  return (
    <>
      <h5 className="card-title">Daftar Maping Groups</h5>
      <DataTable
        columns={columns}
        data={props.mapingGroups}
        pagination
        fixedHeader
        highlightOnHover
        subHeader
        subHeaderComponent={
          <input
            type="text"
            placeholder="Search Modul, Group, Nama Lengkap"
            className="w-50 form-control m-3"
            values={props.search}
            onChange={(e) => props.handleChangeSearch(e.target.value)}
          />
        }
        subHeaderAlign="center"
      />
    </>
  );
};

export default DatatableMapingGroups;
